import { Route, Routes } from "react-router-dom";
import Login from "../../pages/towerHeadAdmin/auth/Login";
import ForgotPassword from "../../pages/towerHeadAdmin/auth/ForgotPassword";
import Dashboard from "../../pages/towerHeadAdmin/Dashboard";
import StaffAdmin from "../../pages/towerHeadAdmin/admin/StaffAdmin";
import MenuPricing from "../../pages/towerHeadAdmin/menu-pricing/MenuPricing";
import ExcelImportProducts from "../../pages/towerHeadAdmin/product/ExcelImportProducts";
import CafeteriaInventory from "../../pages/towerHeadAdmin/cafeteria-inventory/CafeteriaInventory";
import VendorStaff from "../../pages/towerHeadAdmin/Vendor/VendorStaff";
import Vendor from "../../pages/towerHeadAdmin/Vendor/Vendor";
import VendorCompliance from "../../pages/towerHeadAdmin/vendorCompliance/VendorCompliances";
import GalleryList from "../../pages/towerHeadAdmin/gallery/GalleryList";
const TowerHeadAdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/admins" element={<StaffAdmin />} />
      <Route path="/menu-pricing" element={<MenuPricing />} />
      <Route path="/excel-products/:id" element={<ExcelImportProducts />} />
      <Route path="/excel-products" element={<ExcelImportProducts />} />
      <Route path="/cafeteria-inventory" element={<CafeteriaInventory />} />
      <Route path="/vendor" element={<Vendor />} />
      <Route path="/vendor-manager" element={<VendorStaff />} />
      <Route path="/gallery" element={<GalleryList />} />
      <Route path="/vendor-compliance" element={<VendorCompliance />} />


    </Routes>
  );
};
export default TowerHeadAdminRoutes;
